import React, { useState, useEffect } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import MobileMenu from './MobileMenu';
import LoginForm from './LoginForm';

function HeaderOne() {
    const location = useLocation();
    const [isSticky, setIsSticky] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);
    const [activeHashLink, setActiveHashLink] = useState('');

    const scrollToHero = () => {
        if (typeof window === 'undefined') return;
        const hero = document.getElementById('banner');
        if (hero) {
            hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    const handleHomeClick = (event) => {
        setActiveHashLink('');

        if (location.pathname === '/') {
            event.preventDefault();
            scrollToHero();
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (location.pathname !== '/') {
            setActiveHashLink('');
            return;
        }

        if (location.hash === '#about' || location.hash === '#contact') {
            setActiveHashLink(location.hash);
        } else {
            setActiveHashLink('');
        }
    }, [location.pathname, location.hash]);

    const logoBgMaskStyle = {
        WebkitMaskImage: 'url(/assets/img/logo_bg_mask.png)',
        maskImage: 'url(/assets/img/logo_bg_mask.png)',
    };

    const logoBgCloneStyle = {
        WebkitMaskImage: 'url(/assets/img/clone.png)',
        maskImage: 'url(/assets/img/clone3.png)',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'auto 100%',
        maskSize: 'auto 100%',
        WebkitMaskPosition: 'left top',
        maskPosition: 'left top',
    };

    return (
        <>
            {/*============================== Header Area ==============================*/}
            <header className="th-header header-layout1">
                <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
                    {/* Main Menu Area */}
                    <div className="menu-area">
                        <div className="container th-container">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">
                                    <div className="header-logo">
                                        <Link to="/">
                                            <img src="/assets/img/logo.png" alt="Urumavahini" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-auto me-xl-auto">
                                    <nav className="main-menu d-none d-xl-inline-block">
                                        <ul>
                                            <li>
                                                <NavLink
                                                    to="/"
                                                    end
                                                    className={({ isActive }) => (isActive && !activeHashLink ? "active" : undefined)}
                                                    onClick={handleHomeClick}
                                                >
                                                    Home
                                                </NavLink>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/#about"
                                                    className={activeHashLink === '#about' ? 'active' : undefined}
                                                    onClick={() => setActiveHashLink('#about')}
                                                >
                                                    About Us
                                                </Link>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to="/travel-with-dinesh"
                                                    className={({ isActive }) => (isActive ? "active" : undefined)}
                                                >
                                                    Travel with dinesh
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to="/ape-pansala"
                                                    className={({ isActive }) => (isActive ? "active" : undefined)}
                                                >
                                                    Ape pansala
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to="/urumaya"
                                                    className={({ isActive }) => (isActive ? "active" : undefined)}
                                                >
                                                    Urumaya
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to="/ranga-rata"
                                                    className={({ isActive }) => (isActive ? "active" : undefined)}
                                                >
                                                    Ranga Rata
                                                </NavLink>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/#contact"
                                                    className={activeHashLink === '#contact' ? 'active' : undefined}
                                                    onClick={() => setActiveHashLink('#contact')}
                                                >
                                                    Contact us
                                                </Link>
                                            </li>
                                        </ul>
                                    </nav>
                                    <button
                                        type="button"
                                        className="th-menu-toggle d-block d-xl-none"
                                        onClick={() => setIsMobileMenuOpen(true)}
                                    >
                                        <i className="far fa-bars" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="logo-bg logo-bg--clone bg-mask" style={logoBgCloneStyle} />
                        <div className="logo-bg bg-mask" style={logoBgMaskStyle} />
                    </div>
                </div>
            </header>
            <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
            <LoginForm isOpen={isLoginFormOpen} onClose={() => setIsLoginFormOpen(false)} />
        </>

    )
}

export default HeaderOne
